import { all as allCountryCodes } from "country-codes-list";

export interface Country {
  code: string;
  dialCode: string;
  name: string;
  phoneLength: number | [number, number]; // digits excluding country code; [min, max] for variable-length
}

/** Tuned national number lengths where we had explicit rules before expanding the list. */
const LEGACY_PHONE_LENGTH: Partial<Record<string, number | [number, number]>> = {
  IN: 10,
  AF: 9,
  AU: 9,
  BD: 10,
  BR: 11,
  CA: 10,
  CN: 11,
  DE: [10, 11],
  EG: 10,
  FR: 9,
  GB: 10,
  GH: 9,
  ID: [9, 12], 
  IE: [8, 9],  
  IL: 9,
  IT: [9, 10], 
  JP: 10,      
  KE: 9,       
  KR: [9, 10], 
  LK: 9,       
  MY: [9, 10], 
  MX: 10,
  NG: 10,     
  NL: 9,
  NP: 10,
  NZ: [8, 10], 
  PH: 10,
  PK: 10,
  SA: 9,
  SG: 8,
  TH: 9,
  TR: 10,      
  AE: 9,
  US: 10,
  VN: 9,
  ZA: 9,
};

const DEFAULT_PHONE_LENGTH: [number, number] = [6, 15];

function buildCountries(): Country[] {
  const seen = new Set<string>();
  const rows: Country[] = [];

  for (const c of allCountryCodes()) {
    if (!c.countryCode || !c.countryCallingCode) continue;
    if (seen.has(c.countryCode)) continue;
    seen.add(c.countryCode);

    rows.push({
      code: c.countryCode,
      dialCode: `+${c.countryCallingCode}`,
      name: c.countryNameEn,
      phoneLength: LEGACY_PHONE_LENGTH[c.countryCode] ?? DEFAULT_PHONE_LENGTH,
    });
  }

  const collator = new Intl.Collator("en", { sensitivity: "accent" });
  rows.sort((a, b) => collator.compare(a.name, b.name));
  return rows;
}

export const COUNTRIES: Country[] = buildCountries();

export function getCountryName(isoCode: string): string {
  const country = COUNTRIES.find((c) => c.code === isoCode.toUpperCase());
  return country?.name ?? isoCode;
}
